module.exports = __webpack_public_path__ + "img/emoji-expenses@3x.58b4297.png";